import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    InputType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_153_lookup_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Lookup Edit",
        style: {},
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "lookup_name",
                TableName: "lookup_name",
                DisplayName: "Lookup",
                columnNumber: "m1 t1 w1",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Lookup details",
                        BindValue: "cont_Action",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                IncludeLabel: true,
                                Label: "Name",
                                name: "txt_name",
                                BindValue: "txt_name",
                                Json_Attribute: "name",
                                disabled: false,
                                inputType: InputType.TEXT,
                                showInSummary: true,
                                IsVerticalView: true,
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "lookup_items",
                        label: "Items",
                        tableName: "lookup_items",
                        BindValue: "sub_lookupitem",
                        childControls: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                IncludeLabel: true,
                                Label: "Name",
                                name: "txt_subName",
                                BindValue: "txt_subName",
                                Json_Attribute: "name",
                                placeholder: "Enter lookup item name",
                                inputType: InputType.TEXT,
                                showInSummary: false,
                                IsVerticalView: true,
                            },
                        ],
                    },
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    gap: 0,
                    marginTop: 10,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Submit",
                        Label: "Submit",
                        BindValue: "btn_submit",
                        onPressAction: "save",
                        ActionType: "Add",
                        ScreenId: "153_add",
                        style: {
                            backgroundColor: "#22c55e",
                            textColor: "#FFFFFF",
                            padding: 12,
                            borderRadius: 8,
                        },
                    },
                ],
            },
        ],
    },
];
